import {ActivatedRoute} from '@angular/router';
import {Tour} from '@app/common/interfaces/tour';
import {TranslatePipe} from '@ngx-translate/core';
import {ToursComponent} from '../tours/tours.component';
import {Component, inject, model, OnInit} from '@angular/core';
import {AppStateService} from '@app/common/services/app-state.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {
  BookOnlineSectionComponent,
  HeaderComponent,
  PricesTableComponent,
  ShoppingCartComponent,
  SliderComponent,
  VideoComponent
} from '@app/common/ui-kits';
import {GalleriaModule} from "primeng/galleria";

@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.scss'],
  imports: [
    TranslatePipe,
    VideoComponent,
    ToursComponent,
    HeaderComponent,
    SliderComponent,
    PricesTableComponent,
    ShoppingCartComponent,
    BookOnlineSectionComponent,
    GalleriaModule,
  ]
})
export class TourComponent implements OnInit {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly settingsService = inject(AppStateService);

  public tour: Tour | null = null;
  public safeUrl: SafeResourceUrl = '';


  protected images: any = model([]);
  protected expandedDescriptions = new Set<number>();
  responsiveOptions: any[] = [];

  ngOnInit() {
    this.subscribeToUrl();

    this.images.set([
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_2.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_3.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_4.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_6.jpg'}
    ]);
  }

  private subscribeToUrl() {
    const tourName = this.activatedRoute.snapshot.params['tourName'];
    this.tour = this.settingsService.tours.find(t => t.urlKey === tourName) || null;
    if (this.tour?.map) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.tour.map);
    }
  }

  protected isDescriptionExpanded(index: number): boolean {
    return this.expandedDescriptions.has(index);
  }

  protected toggleDescription(index: number): void {
    if (this.expandedDescriptions.has(index)) {
      this.expandedDescriptions.delete(index);
      return;
    }

    this.expandedDescriptions.add(index);
  }

}
